import { create } from "zustand";

import {
  InitializePaginationProperties,
  InitializeSetPaginationProperties,
  PaginationProperties,
  SetPaginationProperties
} from "../../../../../common/utils/pagination_property";

/**
 * useDistribuicaoEpiListaPagination
 */

type State = PaginationProperties;

type Actions = SetPaginationProperties;

export const useDistribuicaoEpiListaPagination = create<State & Actions>((set, get) => ({
  ...InitializePaginationProperties(),
  ...InitializeSetPaginationProperties(set),
}));